export enum DashboardFilterDateRange {
  Last30 = 'Last30',
  Last60 = 'Last60',
  Last90 = 'Last90',
  Last365 = 'Last365',
  ThisWeek = 'ThisWeek',
  ThisMonth = 'ThisMonth',
  ThisYear = 'ThisYear'
}
